import { useEffect } from 'react';

import type { ProductKeys } from '../../../../constants/products';
import { serveSearchPageTimeoutsUX } from '../../../../utils/experiments';

type ResetProductsWithTimeoutProps = {
	setProductsWithTimeout: React.Dispatch<React.SetStateAction<ProductKeys[] | undefined>>;
};

export const ResetProductsWithTimeout = ({
	setProductsWithTimeout,
}: ResetProductsWithTimeoutProps) => {
	useEffect(() => {
		if (!serveSearchPageTimeoutsUX()) {
			return;
		}

		setProductsWithTimeout(undefined);
	}, [setProductsWithTimeout]);

	return null;
};
